const notionCard = {
  notionTitle: "¡Central de Conocimiento GEEQUIP en Notion!",
  notionDescription: "¡Acceda a Notion y vea todos los tutoriales disponibles para usted!",
  notionLink: "Acceder a Tutoriales",
}

export default notionCard;